import {
  fileNameFromPresignedUrlQueryStringRegex,
  fileNameFromPresignedUrlRegex,
  FileToDownload,
  getLastPartOfUrlPath,
} from 'components/atoms/DownloadFilesModal';
import { isPrepareCustomerResultsParentJob, PrepareCustomerResultsJob } from 'interfaces/job';
import { filter } from 'lodash';

const regexMatchPartOf = /Part_(\d+)_of_(\d+)/;

type SelectablePrepareCustomerResultsJob = PrepareCustomerResultsJob & {
  unpublishedExperimentResultIds?: number[];
};

export const getSelectablePrepareCustomerResultsJobs = (jobs?: SelectablePrepareCustomerResultsJob[]) => {
  return filter(jobs, (job) => isPrepareCustomerResultsParentJob(job));
};

export const prepareCustomerResultsUrlToFileToDownload = (
  url: string
): FileToDownload & {
  zipNumber: number;
} => {
  const zipMatch = url.match(regexMatchPartOf);

  // Try to extract filename from query string first, then from path
  const queryStringMatch = url.match(fileNameFromPresignedUrlQueryStringRegex)?.[1];
  const pathMatch = url.match(fileNameFromPresignedUrlRegex)?.[1];

  const fileNameFromUrl = decodeURIComponent(queryStringMatch || pathMatch || getLastPartOfUrlPath(url) || '');

  const zipNumber = zipMatch ? parseInt(zipMatch[1], 10) : Infinity;
  const zipNumberText = zipMatch ? `Zip ${zipMatch[1]} of ${zipMatch[2]}` : undefined;

  return {
    url,
    title: zipNumberText || fileNameFromUrl || url,
    subTitle: zipNumberText && fileNameFromUrl ? fileNameFromUrl : undefined,
    zipNumber,
  };
};
